import React from 'react';
import type { SocialShareLink } from '../../get-data/transform/share-links';
import Items from './items';
import { SharePanelContainer, Title } from './style';

const SharePanel: React.FC<Props> = ({ shareLinks, isMobileCardsLayout = false }) => (
    <SharePanelContainer isMobileCardsLayout={isMobileCardsLayout}>
        {isMobileCardsLayout ? (
            <>
                <Title isMobileCardsLayout={isMobileCardsLayout}>Share this ad</Title>
            </>
        ) : (
            <Title isMobileCardsLayout={false}>Share:</Title>
        )}
        <Items items={shareLinks} />
    </SharePanelContainer>
);

interface Props {
    shareLinks: SocialShareLink[];
    isMobileCardsLayout?: boolean;
}

export default SharePanel;
